import styles from './CadastrarProdutoPopUp.module.css';
import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../form/Input';
import { ProdutosContext } from '../contexts/ProdutosContext';
import { CategoriasContext } from '../contexts/CategoriasContext';
import { fetchWithAuth } from '../utils/auth';

function CadastrarProdutoPopUp({ onClose }) {
  const { carregarProdutos } = useContext(ProdutosContext);
  const { categorias } = useContext(CategoriasContext);
  const [nomeItem, setNomeItem] = useState('');
  const [descricao, setDescricao] = useState('');
  const [preco, setPreco] = useState('');
  const [precoFormatado, setPrecoFormatado] = useState('');
  const [idCategoria, setIdCategoria] = useState('');
  const [imagem, setImagem] = useState('');
  const [disponivel, setDisponivel] = useState(true);
  const [quantidade, setQuantidade] = useState('');
  const [tipoImagem, setTipoImagem] = useState('url'); // 'url' ou 'arquivo'
  const [arquivoImagem, setArquivoImagem] = useState(null);
  const [previewImagem, setPreviewImagem] = useState('');

  const navigate = useNavigate();

  const handlePrecoChange = (e) => {
    let valor = e.target.value.replace(/\D/g, ''); // só dígitos
    if (!valor) {
      setPreco('');
      setPrecoFormatado('');
      return;
    }
    const centavos = parseInt(valor, 10);
    const reais = (centavos / 100).toFixed(2);
    setPreco(reais); // valor numérico para o backend
    setPrecoFormatado(
      `R$ ${reais.replace('.', ',')}`
    );
  };

  const handleArquivoImagem = (e) => {
    const arquivo = e.target.files[0];
    if (arquivo) {
      setArquivoImagem(arquivo);

      // Criar preview da imagem
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImagem(reader.result);
      };
      reader.readAsDataURL(arquivo);
    }
  };

  const cadastroItem = async (e) => {
    e.preventDefault();

    if (!nomeItem || !preco || !idCategoria) {
      alert("Preencha os campos obrigatórios (Nome, Preço e Seção)!");
      return;
    }

    if (tipoImagem === 'url' && !imagem) {
      alert("Por favor, insira a URL da imagem!");
      return;
    }

    if (tipoImagem === 'arquivo' && !arquivoImagem) {
      alert("Por favor, selecione um arquivo de imagem!");
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const estabelecimento_id = localStorage.getItem("estabelecimento_id");

      console.log('🏪 [CADASTRO PRODUTO] ID do estabelecimento:', estabelecimento_id);

      if (!estabelecimento_id) {
        alert("Erro: Estabelecimento não identificado. Por favor, faça login novamente.");
        return;
      }

      const categoriaId = idCategoria;

      let imagemFinal = imagem;

      // Se for upload de arquivo, converter para base64
      if (tipoImagem === 'arquivo' && arquivoImagem) {
        imagemFinal = previewImagem;
      }

      const response = await fetchWithAuth(`${API_URL}/cadastroprodutos`, {
        method: "POST",
        body: JSON.stringify({
          nome_item: nomeItem,
          descricao,
          preco,
          id_categoria: categoriaId,
          imagem: imagemFinal,
          disponivel,
          // Campo em branco = estoque ilimitado (backend guarda null)
          quantidade: quantidade === '' ? null : Number(quantidade),
          id_estabelecimento: estabelecimento_id
        })
      });

      if (!response) {
        // Token expirado ou inválido - fetchWithAuth já fez logout
        return;
      }

      if (response.ok) {
        alert("Produto cadastrado com sucesso!");

        // Recarregar produtos do contexto e aguardar antes de fechar
        if (carregarProdutos) {
          await carregarProdutos();
        }

        if (onClose) {
          onClose();
        } else {
          navigate("/admin/gestaoestabelecimento");
        }
      } else {
        const errorText = await response.text();
        alert(`Erro ao cadastrar o item: ${errorText}`);
      }
    } catch (err) {
      alert(`Erro na requisição: ${err.message}`);
    }
  };

  return (
    <div className={styles.containerCadastro}>
    {/* <div className={styles.headerCadastro}>
        <h2>Cadastrar Novo Produto</h2>
      </div>*/}

      <form onSubmit={cadastroItem} className={styles.formCadastro}>
        <Input
          type="text"
          text="Nome do Item"
          name="nome_item"
          placeholder="Ex: X-Burguer"
          value={nomeItem}
          handleOnChange={(e) => setNomeItem(e.target.value)}
        />
        <Input
          type="text"
          text="Descrição"
          name="descricao"
          placeholder="Breve descrição do produto"
          value={descricao}
          handleOnChange={(e) => setDescricao(e.target.value)}
        />
        <Input
          type="text"
          text="Preço"
          name="preco"
          placeholder="R$ 0,00"
          value={precoFormatado}
          handleOnChange={handlePrecoChange}
        />

        <div className={styles.inputGroup}>
          <label className={styles.label}>Seção</label>
          <select
            className={styles.select}
            value={idCategoria}
            onChange={(e) => setIdCategoria(e.target.value)}
            required
          >
            <option value="">Selecione uma seção</option>
            {categorias.map((cat) => (
              <option key={cat.id_categoria} value={cat.id_categoria}>
                {cat.nome_categoria}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>Disponibilidade</label>
          <div className={styles.radioGroup}>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="disponivel"
                value="true"
                checked={disponivel === true}
                onChange={() => setDisponivel(true)}
              />
              <span>Disponível</span>
            </label>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="disponivel"
                value="false"
                checked={disponivel === false}
                onChange={() => setDisponivel(false)}
              />
              <span>Indisponível</span>
            </label>
          </div>
        </div>

        <Input
          type="number"
          text="Quantidade em Estoque"
          name="quantidade"
          placeholder="Deixe em branco para estoque ilimitado"
          value={quantidade}
          handleOnChange={(e) => setQuantidade(e.target.value)}
          min="0"
        />

        <div className={styles.inputGroup}>
          <label className={styles.label}>Tipo de Imagem</label>
          <div className={styles.radioGroup}>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="tipoImagem"
                value="url"
                checked={tipoImagem === 'url'}
                onChange={() => setTipoImagem('url')}
              />
              <span>URL</span>
            </label>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="tipoImagem"
                value="arquivo"
                checked={tipoImagem === 'arquivo'}
                onChange={() => setTipoImagem('arquivo')}
              />
              <span>Upload de Arquivo</span>
            </label>
          </div>
        </div>

        {tipoImagem === 'url' ? (
          <Input
            type="text"
            text="URL da Imagem"
            name="imagem"
            placeholder="Cole a URL da imagem aqui"
            value={imagem}
            handleOnChange={(e) => setImagem(e.target.value)}
          />
        ) : (
          <div className={styles.inputGroup}>
            <label className={styles.label}>Upload de Imagem</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleArquivoImagem}
              className={styles.fileInput}
            />
            {previewImagem && (
              <div className={styles.previewContainer}>
                <img src={previewImagem} alt="Preview" className={styles.previewImagem} />
              </div>
            )}
          </div>
        )}

        <button className={styles.btn} type="submit">
          Adicionar Produto
        </button>
      </form>
    </div>
  );
}

export default CadastrarProdutoPopUp;
